import { render, staticRenderFns } from "./CHPPLoginLayout.vue?vue&type=template&id=5f8f255b&scoped=true&"
import script from "./CHPPLoginLayout.vue?vue&type=script&lang=ts&"
export * from "./CHPPLoginLayout.vue?vue&type=script&lang=ts&"
import style0 from "./CHPPLoginLayout.vue?vue&type=style&index=0&id=5f8f255b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f255b",
  null
  
)

export default component.exports